import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import { createRoot } from 'react-dom/client';
// import reportWebVitals from './reportWebVitals';
import { StateProvider } from './Components/StateProvider';
import reducer,{ initialState } from './Components/reducer';
//import * as serviceWorker from "./serviceWorker"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   // <React.StrictMode>
    <StateProvider initialState={initialState} reducer={reducer}>
    <App />
    </StateProvider>
   // </React.StrictMode>
);

// reportWebVitals();
